import React, { useState } from 'react';
import './DateFilter.css';

const DateFilter = ({ onDateChange }) => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [timeFilter, setTimeFilter] = useState(''); // 'morning' or 'evening'
  const [isFilterActive, setIsFilterActive] = useState(false);

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  const handleTimeFilterChange = (time) => {
    const newTimeFilter = timeFilter === time ? '' : time;
    setTimeFilter(newTimeFilter);
    setIsFilterActive(startDate || endDate || newTimeFilter !== '');
    onDateChange({ startDate, endDate, timeFilter: newTimeFilter });
  };

  const handleApplyFilter = () => {
    if (startDate || endDate || timeFilter) {
      setIsFilterActive(true);
      onDateChange({ startDate, endDate, timeFilter });
    }
  };

  const handleClearFilter = () => {
    setStartDate('');
    setEndDate('');
    setTimeFilter('');
    setIsFilterActive(false);
    onDateChange({ startDate: '', endDate: '', timeFilter: '' });
  };

  const handleQuickFilter = (days) => {
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - days);
    
    const startStr = start.toISOString().split('T')[0];
    const endStr = end.toISOString().split('T')[0];
    
    setStartDate(startStr);
    setEndDate(endStr);
    setIsFilterActive(true);
    onDateChange({ startDate: startStr, endDate: endStr, timeFilter });
  };

  return (
    <div className="date-filter-container">
      <div className="date-filter-header">
        <h3>Filters</h3>
        {isFilterActive && (
          <button className="clear-filter-btn" onClick={handleClearFilter}>
            Clear
          </button>
        )}
      </div>
      
      <div className="date-filter-main-row">
        <div className="date-filter-controls">
          <div className="date-input-group">
            <label htmlFor="startDate">Start:</label>
            <input
              type="date"
              id="startDate"
              value={startDate}
              onChange={handleStartDateChange}
              className="date-input"
            />
          </div>
          
          <div className="date-input-group">
            <label htmlFor="endDate">End:</label>
            <input
              type="date"
              id="endDate"
              value={endDate}
              onChange={handleEndDateChange}
              className="date-input"
              min={startDate || undefined}
            />
          </div>
          
          <button className="apply-filter-btn" onClick={handleApplyFilter}>
            Apply
          </button>
        </div>
        
        <div className="filter-actions-row">
          <div className="time-filter-section">
            <span className="time-filter-label">Time:</span>
            <button 
              className={`time-filter-btn ${timeFilter === 'morning' ? 'active' : ''}`}
              onClick={() => handleTimeFilterChange('morning')}
            >
              Morning
            </button>
            <button 
              className={`time-filter-btn ${timeFilter === 'evening' ? 'active' : ''}`}
              onClick={() => handleTimeFilterChange('evening')}
            >
              Evening
            </button>
          </div>
          
          <div className="quick-filters">
            <span className="quick-filter-label">Quick:</span>
            <button className="quick-filter-btn" onClick={() => handleQuickFilter(7)}>
              7D
            </button>
            <button className="quick-filter-btn" onClick={() => handleQuickFilter(30)}>
              30D
            </button>
            <button className="quick-filter-btn" onClick={() => handleQuickFilter(90)}>
              90D
            </button>
          </div>
        </div>
      </div>
      
      {isFilterActive && (
        <div className="active-filter-indicator">
          <span>Active: </span>
          <strong>
            {[
              startDate && endDate ? `${startDate} to ${endDate}` : startDate ? `From ${startDate}` : endDate ? `Until ${endDate}` : '',
              timeFilter === 'morning' ? 'Morning' : timeFilter === 'evening' ? 'Evening' : ''
            ].filter(Boolean).join(' | ')}
          </strong>
        </div>
      )}
    </div>
  );
};

export default DateFilter;

